import React, { useState } from "react";
import { CommonGrid2 } from "../../common-components/StyledComponents";
import PageNotFoundImage from "../../../assets/images/PageNotFound.png";
import { CustomDiv } from "../../chat-bot/style";
import { Typography } from "@mui/material";
import CommonButton from "../../../component/Button";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { platformBlackLogo } from "../../../utils/logo";

export default function PageNotFound() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  return (
    <CommonGrid2
      container
      alignItems={"center"}
      height={"100vh"}
      sx={{
        padding: {
          xs: "2rem 1rem",
          sm: "2rem 2rem",
          md: "2rem 4rem",
          lg: "2rem 0rem 2rem 6rem",
        },
      }}
      flexWrap={"wrap"}
    >
      <CommonGrid2 item size={{ xs: 12, md: 7 }}>
        <CustomDiv width="fit-content">
          {platformBlackLogo({height: "50px"})}
        </CustomDiv>
        <CustomDiv
          style={{ borderLeft: "6px solid #D7C4F3" }}
          padding="0px 0px 0px 1.2rem"
        >
          <Typography
            variant="h1"
            fontWeight="700"
            marginTop={"1.5rem"}
            sx={{
              fontSize: {
                xs: "30px",
                sm: "40px",
                md: "45px",
                lg: "50px",
              },
            }}
          >
            404 – Page Not Found
          </Typography>
          <Typography
            variant="h6"
            fontSize={"18px"}
            marginTop={"0.8rem"}
            lineHeight={"1.8rem"}
            color="#5B738B"
            sx={{
              fontSize: {
                xs: "14px",
                sm: "15px",
                md: "16px",
                lg: "18px",
              },
            }}
          >
            Oops! The page you’re looking for doesn’t exist or may have been
            moved.
            <br />
            Please check the URL or return to the homepage.
          </Typography>
          <CommonButton
            value="Go Back Home"
            startIcon={loading ? "" : <ArrowBackIcon />}
            onClick={() => {
              setLoading(true);
              navigate("/auth/login");
            }}
            variant="contained"
            fontWeight={600}
            marginTop="2.5rem"
            padding={"10px 2rem"}
            gap={loading ? "10px" : "0px"}
            loading={loading}
            disabled={loading}
          />
        </CustomDiv>
      </CommonGrid2>
      <CommonGrid2 item size={{ xs: 12, md: 5 }}>
        <img
          src={PageNotFoundImage}
          width={"80%"}
          height={"100%"}
          alt="Maintenance Mode"
        />
      </CommonGrid2>
    </CommonGrid2>
  );
}
